import { Component, Prop, Emit, Watch, Vue } from "vue-property-decorator";
import Modal from "@/components/modalBase/modalBase";
import Loading from "@/components/loading/loading";
import { Action } from "vuex-class";

@Component({
  components: {
    Modal,
    Loading
  }
})
export default class ModalTemp extends Vue {
  @Prop({ default: false }) show!: Boolean;
  @Prop({ default: "xsmall" }) modalSize!: String;
  @Prop({ default: false }) titleIcon!: String;
  @Prop({ default: false }) title!: String;
  // @Prop({ default: false }) caseOne!: Boolean;
  // @Prop({ default: false }) caseTwo!: Boolean;
  // @Prop({ default: false }) caseThree!: Boolean;
  // @Prop({ default: false }) caseFour!: Boolean;

  @Prop({ default: 0 }) card;

  @Action action_validateCreditCard;

  step = 0;
  cardNumber = "";
  errMessage = "";
  loading = false;
  caseOne = true;
  caseTwo = false;
  caseThree = false;
  caseFour = false;

  startStory() {
    this.caseOne = false;
    this.caseTwo = true;
  }
  backStep1() {
    this.caseOne = true;
    this.caseTwo = false;
  }

  startStory2() {
    this.caseOne = false;
    this.caseTwo = false;
    this.caseThree = true;
  }
  backStep2() {
    this.caseOne = false;
    this.caseTwo = true;
    this.caseThree = false;
  }
  startStory3() {
    this.caseOne = false;
    this.caseTwo = false;
    this.caseThree = false;
    this.caseFour = true;
  }


  modalClose() {
    this.cardNumber = "";
    this.errMessage = "";
    this.$emit("cancel", this.card);
  }

  modalSucess() {
    this.cardNumber = "";
    this.errMessage = "";
    this.$emit("sucess", this.card);
  }

  async checkNumber() {
    this.loading = true;
    this.errMessage = "";
    this.step = 0;
    if (this.cardNumber.length < 12) {
      this.errMessage = "El número de tu tarjeta debe tener al menos 12 dígitos";
      this.step = 3;
      return;
    }
    const data = {
      id: this.card.id,
      credit_card: {
        credit_card_number: this.cardNumber
      }
    };
    try {
      await this.action_validateCreditCard(data);
      this.$swal({
        title: "Tarjeta validada"
      });
      this.modalClose();
    } catch (e) {
      this.errMessage =
        (e && e.response && e.response.data && e.response.data.message) ||
        "Error verificando tu tarjeta de crédito, verifica tus datos";
      this.step = 3;
    }
    this.loading = false;
  }
}
